const articleSwiper = new Swiper('.swiper.article-swiper', {
    slidesPerView: 1.5,
    spaceBetween: 22,
    autoHeight: true,
    slidesOffsetAfter: 20,
    slidesOffsetBefore: 20,
    breakpoints: {
        750: {
            slidesPerView: 4,
            spaceBetween: 32,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
        }
    }
});

const products = document.querySelector('.article-swiper .swiper-wrapper');
const swiperClass = products.querySelectorAll('.swiper');
  
var recSwiperArray = [];
var recClass;
var recPag;
for (var i = 0; i < swiperClass.length; ++i) {
    recClass = '.recommendations-product-' + i;
    recPag = '.swiper-pagination.recprod-' + i;
    recSwiperArray[i] = new Swiper(recClass, {
        slidesPerView: 1,
        pagination: {
            el: recPag,
            clickable: true,
        }
    });
};